// extracted by mini-css-extract-plugin
export default {"returns_help_button":"_1m2t","returns_help_icon":"_3Qbt","returns_help_url":"_1F-b","returns_help_text":"tREe"};